import React from 'react';
import {Link} from 'react-router-dom';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBook, faPencil, faMoneyBill, faPerson, faUniversity, faAdd, faComment} from '@fortawesome/free-solid-svg-icons';

const AdminMenu = ({path}) => {
    const menuItems = [
        { path: '/admin/blog/', icon: faBook, text: 'مقاله‌ها' },
        { path: '/admin/blog/new-post', icon: faPencil, text: 'مقاله‌ی جدید' },
        { path: '/admin/course', icon: faUniversity, text: 'دوره‌ها' },
        { path: '/admin/course/new/overview', icon: faAdd, text: 'دوره‌ی جدید' },
    ];

    return (
        <div className='m-5 relative text-black bg-gray-100 rounded-md'>
            <ul className='flex-col'>
                {menuItems.map((item, index) => (
                    <li
                        key={index}
                        className='w-full flex items-center cursor-pointer hover:bg-light-light hover:text-light-primary transition-colors'
                    >
                        <Link to={item.path} className='w-full px-5 py-5'>
                            <FontAwesomeIcon icon={item.icon} className='ml-4' />
                            <span>{item.text}</span>
                        </Link>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default AdminMenu;
